'use client'

import { QueryDocument } from '@models'
import { SectionWrapper, SimpleDocumentRenderer } from '@components/common'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

export type ContentSectionData = Partial<{
  document: QueryDocument[]
}>

type ContentSectionProps = ContentSectionData

export function ContentSection({ document }: ContentSectionProps) {
  const styles = getStyles(defaultStyles)

  return (
    <SectionWrapper
      csx={{
        wrapper: styles('sectionWrapper').sx,
      }}
    >
      {document && <SimpleDocumentRenderer document={document} />}
    </SectionWrapper>
  )
}
